<template>
  <div class="ma-2">
    <data-iterator :headers="payloadHeaders" :payload="payload"></data-iterator>
    <v-dialog v-model="drawer" absolute bottom temporary right width="500">
      <v-card elevation="0" height="100%">
         <v-card-title class="primary white--text px-4">
          <span class="title">  {{ modelObj._id ? 'Update Route' : 'Add Route'}} </span>
        </v-card-title>
        <v-form ref="form">
          <v-card-text>
            <v-row class="mx-4">
              <v-col cols="12">
                <v-text-field outlined dense hide-details label="Name" v-model="modelObj.name" :rules="setValidation('requiredValidation')"></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-textarea outlined dense hide-details label="Description" v-model="modelObj.description"></v-textarea>
              </v-col>
            </v-row>
          </v-card-text>
        </v-form>
        <v-divider></v-divider>
        <v-card-actions>
          <v-layout class="d-flex justify-center">
            <v-btn color="success" class="mx-2" @click="saveUpdateHandler()">{{modelObj._id ? 'Update' : 'Save'}}</v-btn>
            <v-btn @click="drawer= false" color="error">Cancel</v-btn>
          </v-layout>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      drawer: false,
      listOfClasses: [],
      modelObj: {},
      payload: {
        showBackBtn: () => this.$router.go(-1),
        create: () => this.drawer = true,
        items: [],
        showSelect: false,
        actionsList: [{
          click: (item) => this.editHandler(item._id),
          icon: 'mdi-pencil',
          color: 'primary'
        }, {
          click: (item) => this.deleteHandler(item._id),
          icon: 'mdi-delete',
          color: 'error'
        }]
      }
    }
  },
  components: {
    'data-iterator': () => import('@/components/DataIterator.vue')
  },
  watch: {
    drawer(val) {
      if (!val) {
        this.modelObj = {}
      }
    }
  },
  mounted () {
    this.getListOfBooks()
    this.getListOfClasses()
  },
  computed: {
    payloadHeaders () {
      return [{
        text: 'Name',
        value: 'name'
      }, {
        text: 'Description',
        value: 'description'
      }, {
        text: 'Actions',
        value: 'actions'
      }]
    }
  },
  methods: {
    getListOfClasses () {
      this.$_execute('get', 'classes').then(response => {
        this.listOfClasses = response.data
      })
    },
    getListOfBooks () {
      this.$_execute('get', 'routes').then(response => {
        this.payload.items = response.data
      })
    },
    saveUpdateHandler () {
      let url = this.modelObj._id ? `routes/${this.modelObj._id}` : `/routes`
      let method = this.modelObj._id ? `put` : `post`
      this.$_execute(method, url, this.modelObj).then(() => {
        this.$root.$emit('snackbar', { message: this.modelObj._id ? 'Updated Successfully' : 'Saved Successfully', color: 'success'})
        this.$refs.form.reset()
        this.modelObj = {}
        this.drawer = false
        this.getListOfBooks()
      })
    },
    editHandler (id) {
      this.$_execute('get', `routes/${id}`).then(response => {
        this.drawer = true
        this.modelObj = response.data[0]
      })
    },
    deleteHandler (id) {
      this.$root.$emit('delete', {
        module: 'routes',
        _id: id,
        onResolve: () => {
          this.dialog = false
          this.$root.$emit('snackbar', { message: `Deleted Successfully`, color: 'success' })
          this.getListHandler()
        }
      })
    }
  }
}
</script>
